import React from "react";
import { Link } from "react-router-dom";

const AccountDeletion: React.FC = () => (
  <main className="min-h-screen bg-slate-50 px-4 py-10 text-slate-800 sm:px-6">
    <article className="mx-auto max-w-3xl overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
      <header className="bg-gradient-to-r from-blue-800 to-cyan-600 px-6 py-8 text-white sm:px-10">
        <img
          src="/vodovod-doboj-logo.png"
          alt="Vodovod Doboj"
          className="mb-6 h-14 w-auto max-w-full rounded bg-white p-2 object-contain"
        />
        <h1 className="text-3xl font-bold">Brisanje korisničkog naloga</h1>
        <p className="mt-2 text-blue-50">Moj Vodovod Doboj</p>
      </header>

      <div className="space-y-7 px-6 py-8 leading-7 sm:px-10">
        <section>
          <h2 className="mb-2 text-xl font-semibold">Kako poslati zahtjev</h2>
          <ol className="list-decimal space-y-2 pl-6">
            <li>
              Pošaljite email na{" "}
              <a className="font-semibold text-blue-700 underline" href="mailto:info@vodovod-doboj.com?subject=Zahtjev%20za%20brisanje%20naloga%20Moj%20Vodovod%20Doboj">
                info@vodovod-doboj.com
              </a>.
            </li>
            <li>U naslov upišite „Zahtjev za brisanje naloga“.</li>
            <li>Navedite email adresu naloga i šifru pripadajućeg vodomjera radi provjere identiteta.</li>
          </ol>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Šta se briše</h2>
          <p>
            Nakon provjere zahtjeva brišu se korisnički profil, pristup nalogu,
            postavke obavještenja i podaci koje je korisnik sam unio. Poslovni
            podaci o vodomjeru, očitanjima i računima mogu se zadržati kada je to
            potrebno radi zakonskih i knjigovodstvenih obaveza, ali više neće biti
            vezani za aktivni pristup obrisanog naloga.
          </p>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Rok obrade</h2>
          <p>
            Zahtjev se obrađuje nakon provjere identiteta, najkasnije u roku od
            30 dana. Ako su potrebne dodatne informacije, korisnik će biti
            kontaktiran na email adresu naloga.
          </p>
        </section>

        <p className="border-t border-slate-200 pt-6 text-sm text-slate-500">
          Više informacija nalazi se u <Link className="text-blue-700 underline" to="/privacy">Politici privatnosti</Link>.
        </p>
      </div>
    </article>
  </main>
);

export default AccountDeletion;
